import { getGlobals } from "storyblok/api"
import { getAllServicePagePaths, getService, getServiceArchive } from "storyblok/services"
import CTABanner from "components/DynamicComponent/atoms/CTABanner"
import Meta from "components/Meta"
import HeaderImage from "components/DynamicComponent/atoms/HeaderImage"
import PageIntro from "components/DynamicComponent/molecules/PageIntro"
import DynamicComponent from "components/DynamicComponent"
import { Crumb } from "components/Breadcrumbs"
import StoryblokVisualEditor from "components/StoryblokVisualEditor"

export default function ServicePage({ story, serviceCategory, meta, category, slug }) {
  return (
    <>
      <Meta info={meta} />
      <main data-pagefind-body>
        <HeaderImage blok={story?.content} />

        <StoryblokVisualEditor story={story?.content}>
          <PageIntro
            blok={{
              image: story?.content?.thumbnail,
              heading: story?.content?.title,
              content: story?.content?.description,
              ...story?.content,
            }}
          >
            {category && slug ? (
              <nav aria-label="Breadcrumb" className="pt-6">
                <ol className="mx-auto w-full max-w-screen-xl">
                  <Crumb {...{ text: "Home", href: "/" }} />
                  <Crumb {...{ text: serviceCategory, href: `/services/${category}` }} />
                  <Crumb {...{ text: story?.content?.title, href: `/services/${category}/${slug}`, last: true }} />
                </ol>
              </nav>
            ) : null}
          </PageIntro>
        </StoryblokVisualEditor>
        {story?.content?.body?.map((blok) => (
          <DynamicComponent blok={blok} key={blok._uid} />
        ))}
      </main>
      <CTABanner />
    </>
  )
}

export async function getStaticProps({ params: { category, slug }, preview = null }) {
  const globals = await getGlobals()
  const story = await getService(`services/${category}/${slug}`, preview)
  const serviceCategory = await getServiceArchive(`services/${category}`, false)

  return {
    props: {
      story,
      globals: globals ?? null,
      meta: story?.content?.twentysixty_seo ?? null,
      slug,
      category,
      serviceCategory: serviceCategory?.content?.title ?? null,
      preview,
    },
  }
}

export async function getStaticPaths() {
  return {
    paths: await getAllServicePagePaths(),
    fallback: false,
  }
}
